import { useRef } from 'react';

import {
	Box,
	DotsHorizontalOutline,
	IconButton,
	PlusOutline,
	Popover,
	PopoverContent,
	PopoverTrigger,
	Portal,
	rem,
	useBreakpointValue,
	useDisclosure,
} from '@bonusly/design-system';

interface CollapsedButtonsProps {
	buttons: any[]; // Should we use a type here?
}

export const CollapsedButtons = ({ buttons }: CollapsedButtonsProps) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const isMobile = useBreakpointValue({ base: true, sm: false });
	const contentRef = useRef<HTMLDivElement>(null);

	return (
		<Popover isLazy={false} isOpen={isOpen} onClose={onClose} placement="top-start">
			<PopoverTrigger>
				<IconButton
					aria-label="More actions"
					icon={isMobile ? <PlusOutline /> : <DotsHorizontalOutline />}
					borderRadius={rem(10)}
					boxSize={rem(40)}
					color="text.default"
					fontSize={rem(24)}
					onClick={onOpen}
					_hover={{
						background: 'secondary.bgAlpha',
					}}
				/>
			</PopoverTrigger>

			<Portal>
				<PopoverContent width="fit-content" bg="bg.surface" borderColor="border.default" borderWidth="1px">
					<Box p={1} ref={contentRef}>
						{buttons}
					</Box>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};
